import type { ValidationSchema } from "../validation";
import type { IIntegrationInput } from "./iintegration";

export const schemaIntegrationInput: ValidationSchema<IIntegrationInput> = {
    type: { required: true },
    active: { required: true },
    name: { required: true },
    apiKey: { required: true },
};
